import { render, staticRenderFns } from "./WpLegends.vue?vue&type=template&id=1e15c103&"
import script from "./WpLegends.vue?vue&type=script&lang=js&"
export * from "./WpLegends.vue?vue&type=script&lang=js&"
import style0 from "./WpLegends.vue?vue&type=style&index=0&id=1e15c103&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports